import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!localStorage.getItem("fto_install_dismissed")) setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!show || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
    setDeferred(null);
  };
  const dismiss = () => {
    localStorage.setItem("fto_install_dismissed", "1");
    setShow(false);
  };

  return (
    <div data-testid="install-prompt" className="fixed bottom-28 md:bottom-24 left-4 right-4 md:left-auto md:right-6 md:w-80 z-[55] bg-card border-2 border-accent p-4 block-shadow-acid fade-up">
      <button onClick={dismiss} data-testid="install-dismiss" className="absolute top-2 right-2 text-muted-foreground hover:text-white"><X size={18} /></button>
      <div className="overline text-xs text-accent mb-1">Sideload the app</div>
      <p className="text-sm mb-3">Install FTO to your device for full-screen, offline-ready listening.</p>
      <button data-testid="install-btn" onClick={install} className="w-full bg-accent text-black font-bold overline text-xs py-3 flex items-center justify-center gap-2 hover:bg-white transition-colors">
        <Download size={16} /> Install App
      </button>
    </div>
  );
}
